module.exports = __webpack_public_path__ + "static/ec-pfs-desktop-24b8efa1125daf89c6267c4a0965aa11.png";